import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { NotificationsService } from 'src/app/shared/notifications/notifications.service';
import { CalcularPMZDTO, Precificacao, Product } from '../precificacao';
import { PrecificacaoService } from '../precificacao.service';
import * as FileSaver from 'file-saver';
import jspdf from 'jspdf';
import { isNgTemplate } from '@angular/compiler';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';

@Component({
  selector: 'app-precificacao-analise',
  templateUrl: './precificacao-analise.component.html',
  styleUrls: ['./precificacao-analise.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PrecificacaoAnaliseComponent implements OnInit {

  cols: any[];

  _selectedColumns: any[];

  products: any[] = [];
  precificacao: Precificacao[];
  exportColumns: any[];
  tot: number;
  tota: number;
  totm: number;
  tots: number;
  totCMVCusto: number;
  totCMVVenda: number;

  tota_tot: number = 0;
  totm_tot: number = 0;
  totm_tots: number = 0;
  totCMVCusto_totCMVVenda: number = 0;
  tributacao: any[];

  first = 0;
  rows = 50;
  last = 50;

  constructor(private precificacaoService: PrecificacaoService, private notificationsService: NotificationsService, private localStorage: LocalStorageService) { }

  ngOnInit(): void {

    this.cols = [
      { field: 'departamento', header: 'dpt.' },
      { field: 'unidadeDepositoUltimaCompra', header: 'Deposito Ultima Compra' },
      { field: 'quantidade', header: 'quantidade' },
      { field: 'precoUnitario', header: 'Preço Unitário', editable: true },
      { field: 'valorBruto', header: 'Valor Bruto' },
      { field: 'ValorSimplesNacional', header: 'Simples Nacional' },
      { field: 'taxaCofins', header: 'Tx. Cofins' },
      { field: 'valorCofins', header: 'Valor Cofins' },
      { field: 'frete', header: 'Frete' },
      { field: 'desconto', header: 'Desconto' },
      { field: 'despesa', header: 'Despesa' },
      { field: 'st', header: 'ST' },
      { field: 'freteSecundario', header: 'Frete Secundario' },
      { field: 'custoUltimaCompra', header: 'Custo Ultima Compra' },
      { field: 'custoMedio', header: 'Custo Medio' },
      { field: 'quantidadeVendida', header: 'qtd. Vendida' },
      { field: 'curvaAbcqtd', header: 'Curva ABC Qtd.' },
      { field: 'total', header: 'Vlr Vendido' },
      { field: 'curvaAbcvalor', header: 'Curva ABC valor' },
      { field: 'icmsSaida', header: 'ICMS Saida' },
      { field: 'qtd', header: 'Estoque' },
      { field: 'pisSaidaTerceiro', header: 'Pis Terceiro' },
      { field: 'CofinsSaidaTerceiro', header: 'Cofins Terceiro' },
      { field: 'pmz', header: 'PMZ' },
      { field: 'plz', header: 'PLZ' },
      { field: 'indicador', header: 'Indicador' },
      { field: 'vlrTotalMargem', header: 'Novo Tot. Margem', color: 'blue' },
      { field: 'precoVendaProduto', header: 'Preço Venda' },
      { field: 'vlrTotalMargemAtual', header: 'Total Margem Atual' },
      { field: 'percDifPrecoVenda', header: 'Dif. Preço' },
      { field: 'mmi', header: '<=>' },
      { field: 'lucroDesejado', header: 'Lucro Desejado', editable: true },
      { field: 'precoVendaSugerido', header: 'Preço Sugerido', editable: true },
      { field: 'produto', header: 'Produto' },
      { field: 'descricao', header: 'Descricao' },
      { field: 'segmento', header: 'Segmento' },
      { field: 'categoria', header: 'Categoria' },
      { field: 'subSegmento', header: 'Sub Segmento' },
    ];

    //this.cols =this.cols.sort((a, b) => (a.header < b.header ? -1 : 1));

    this.tributacao = [
      { reducao: 1, icms: 0.18, codigo: 100 },
      { reducao: 1, icms: 0.12, codigo: 101 },
      { reducao: 1, icms: 0.25, codigo: 102 },
      { reducao: 0, icms: 0, codigo: 103 },
      { reducao: 0, icms: 0, codigo: 104 },
      { reducao: 0, icms: 0, codigo: 105 },
      { reducao: 0.3889, icms: 0.18, codigo: 106 },
      { reducao: 0, icms: 0, codigo: 107 },
      { reducao: 0.5834, icms: 0.18, codigo: 108 },
      { reducao: 0.5834, icms: 0.12, codigo: 109 },
      { reducao: 0.6667, icms: 0.18, codigo: 110 },
      { reducao: 0.3112, icms: 0.18, codigo: 111 },
      { reducao: 0.3112, icms: 0.18, codigo: 112 },
      { reducao: 0, icms: 0.18, codigo: 113 },
      { reducao: 0.4667, icms: 0.12, codigo: 114 },
      { reducao: 0, icms: 0, codigo: 115 },
      { reducao: 0, icms: 0, codigo: 116 },
      { reducao: 0.4, icms: 0.18, codigo: 117 },
      { reducao: 0.3112, icms: 0.18, codigo: 118 },
      { reducao: 0.7556, icms: 0.12, codigo: 119 },
      { reducao: 0.05, icms: 0.18, codigo: 120 },
      { reducao: 1, icms: 0.07, codigo: 121 },
      { reducao: 0.4889, icms: 0.18, codigo: 122 },
      { reducao: 0.7, icms: 0.18, codigo: 123 },
      { reducao: 0, icms: 0, codigo: 124 },
      { reducao: 0, icms: 0, codigo: 125 },
      { reducao: 0, icms: 0, codigo: 126 },
      { reducao: 1, icms: 0.18, codigo: 127 },
      { reducao: 0, icms: 0, codigo: 128 },
      { reducao: 0, icms: 0, codigo: 129 },
      { reducao: 0.0556, icms: 0.18, codigo: 130 },
      { reducao: 0.7, icms: 0.18, codigo: 131 },
      { reducao: 1, icms: 0.18, codigo: 200 },
      { reducao: 1, icms: 0.18, codigo: 300 },
      { reducao: 0, icms: 0, codigo: 900 },
      { reducao: 0, icms: 0, codigo: 999 },
    ];

    this._selectedColumns = this.cols;



    if (this.localStorage.hasItem('precificacao')) {
      this.precificacao = (JSON.parse(this.localStorage.getItem('precificacao'))) as Precificacao[];
    } else {
      this.getPreciicacao();
    }

  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  getTotais() {
    this.tot = 0;
    this.tota = 0;
    this.totm = 0;
    this.tots = 0;
    this.totCMVCusto = 0;
    this.totCMVVenda = 0;

    this.precificacao.forEach(element => {
      this.tot += element.total ?? 0;
      this.tota += element.vlrTotalMargemAtual ?? 0;
      this.totm += element.vlrTotalMargem ?? 0;
      this.tots += ((element.precoVendaSugerido ?? 0) * (element.quantidadeVendida ?? 0));
      this.totCMVCusto += element.cmvCusto ?? 0;
      this.totCMVVenda += element.cmvVenda ?? 0;
    });
    this.tota_tot = Number((100 * this.tota / this.tot).toFixed(2));
    this.totm_tot = Number((100 * this.totm / this.tot).toFixed(2));
    this.totm_tots = Number((100 * this.totm / this.tots).toFixed(2));
    this.totCMVCusto_totCMVVenda = Number((100 * this.totCMVCusto / this.totCMVVenda).toFixed(2));
    //this.tota_tot= Number(Number(1.341).toFixed(2))

    console.log(this.tot)
    console.log(this.tota)
    console.log(this.totm)
    console.log(this.tots)

    console.log(this.tota / this.tot)
    console.log(this.totm / this.tot)
    console.log(this.totm / this.tots)
    console.log(this.tot / this.tots)

    console.log(this.totCMVCusto)
    console.log(this.totCMVVenda)
    console.log(this.totCMVCusto / this.totCMVVenda)
  }



  salvar() {
    console.log(this.precificacao)
    this.localStorage.setItem('precificacao', JSON.stringify(this.precificacao));
  }


  getPreciicacao() {
    this.precificacaoService.getPrecificacao().subscribe(
      (res) => {
        if (res) {
          this.precificacao = res;
          this.getTotais();
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  beforeUpdate(event) {
  }

  afterUpdate(event) {

    switch (event.field) {
      case 'precoUnitario':
        this.precoUnitarioAfterUpdate(event)
        break;
      case 'vlrTotalMargem':
        this.percAfterUpdate(event)
        break;
      case 'lucroDesejado':
        this.lucroDesejadoAfterUpdate(event)
        break;
      case 'precoVendaSugerido':
        this.precoVendaSugeridoAfterUpdate(event)
        break;
    }
    console.log(event)
    this.salvar()
    this.getTotais()
  }

  precoUnitarioAfterUpdate(event) {
    let prod: Precificacao = event.data;
    if (prod.precoUnitario) prod.precoUnitario = Number(prod.precoUnitario.toString().replace(',', '.'))
    if (prod.precoUnitario && prod.precoUnitario > 0) {


      let trib = this.tributacao.filter(item => item.codigo == prod.tributacaoIcmsVenda)[0]
      prod.icmsSaida = trib ? trib?.icms * trib?.reducao : 0;
      prod.custoProdutoUltimaCompra = Number((((prod.quantidade * prod.precoUnitario) - ((prod.quantidade * prod.precoUnitario) * (prod.txIcms * (prod.baseIcms / prod.valorBruto))) - ((prod.quantidade * prod.precoUnitario) * prod.taxaPis) - ((prod.quantidade * prod.precoUnitario) * prod.taxaCofins) - prod.valorSimplesNacional - prod.desconto + prod.frete + prod.despesa + prod.st) / prod.quantidade).toFixed(2))
      let nTotalImpostosIncidencia = (prod.icmsSaida + prod.pisSaidaTerceiro + prod.cofinsSaidaTerceiro) * 100
      prod.markupDivisorPMZ = 100 - nTotalImpostosIncidencia
      prod.pmz = Number((prod.custoProdutoUltimaCompra / (prod.markupDivisorPMZ / 100)).toFixed(2))
      prod.plz = Number((prod.custoProdutoUltimaCompra / ((prod.markupDivisorPMZ / 100) - prod.percCusto)).toFixed(2))
      let nTotalIncidencias = (prod.icmsSaida + prod.pisSaidaTerceiro + prod.cofinsSaidaTerceiro + prod.lucroDesejado + prod.percCusto) * 100 //+ prod.indicadorPrecoAntesMargem
      prod.markupDivisorPrecoSugerido = 100 - nTotalIncidencias
      prod.precoVendaSugerido = Number((prod.custoProdutoUltimaCompra / (prod.markupDivisorPrecoSugerido / 100)).toFixed(2))

    }

    prod.cmvCusto = prod.quantidadeVendida * prod.custoProdutoUltimaCompra

  }

  precoVendaSugeridoAfterUpdate(event) {

    let prod: Precificacao = event.data;
    prod.precoVendaSugerido = Number(prod.precoVendaSugerido.toString().replace(',', '.'))
    if (prod.precoVendaSugerido == 0) {
      prod.lucroDesejado = -999999
    } else {
      prod.lucroDesejado = Number(((prod.precoVendaSugerido - prod.precoVendaSugerido * (prod.percCusto + prod.percImposto) - prod.custoProdutoUltimaCompra) / prod.precoVendaSugerido).toFixed(2))
    }

    prod.vlrTotalMargem = Number(((prod.precoVendaSugerido * prod.lucroDesejado) * prod.quantidadeVendida).toFixed(2))

    prod.cmvVenda = (prod.quantidadeVendida * prod.precoVendaSugerido)

    let diff = prod.precoVendaSugerido - prod.precoVendaProduto

    prod.percDifPrecoVenda = Number((Math.abs(diff) / prod.precoVendaProduto).toFixed(2))
    if (diff == 0) {
      prod.mmi = 0
    } else {
      prod.mmi = Math.abs(diff) / diff
    }
  }

  percAfterUpdate(event) {
    console.log(event)



  }

  lucroDesejadoAfterUpdate(event) {
    let prod: Precificacao = event.data;


    if (prod.lucroDesejado) {
      prod.lucroDesejado = Number(prod.lucroDesejado.toString().replace(',', '.'))
      let nTotalImpostosIncidencia = (prod.icmsSaida + prod.pisSaidaTerceiro + prod.cofinsSaidaTerceiro)

      let nBasePrecoSugerido = (nTotalImpostosIncidencia + Number(prod.lucroDesejado) + prod.percCusto) * 100
      nBasePrecoSugerido = 100 - nBasePrecoSugerido
      prod.precoVendaSugerido = Number(((prod.custoProdutoUltimaCompra / nBasePrecoSugerido) * 100).toFixed(2))
    } else {
      prod.precoVendaSugerido = prod.custoProdutoUltimaCompra / (prod.markupDivisorPrecoSugerido / 100)
    }

    prod.vlrTotalMargem = Number(((prod.precoVendaSugerido * prod.lucroDesejado) * prod.quantidadeVendida).toFixed(2))
  }






  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.precificacao);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "precificacao");
    });
  }



  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
}
